var module = angular.module('octopusApp.tenants');

module.controller('TenantSettingsController', function($scope, $q, $location, $state, $stateParams, tenantState, busy, octopusRepository, unsavedChanges, octoDialog, missingTenantVariablesLoader) {
    var vm = this;
    var tenantId = tenantState.tenantId;
    vm.isLoading = busy.create();
    vm.isSaving = busy.create();

    vm.save = save;
    vm.deleteTenant = deleteTenant;
  

    function init() {
        if (tenantId) {
            tenantState.load().then(function(tenant){ vm.tenant = tenant; });
            tenantState.missingVariables = missingTenantVariablesLoader.missingVariables(tenantId);
        } else {
            vm.tenant = { Id: null, Name: '', ProjectIds: [], ProjectEnvironments: {} };
        }
    }
    
    function save() {
        var doSave = vm.tenant.Id ?
            octopusRepository.Tenants.modify(vm.tenant).then(function() {
                unsavedChanges.saved();
                //$location.path('/tenants/'+ vm.tenant.Id);
                $state.reload();
            }):
            octopusRepository.Tenants.create(vm.tenant).then(function(tenant){
                unsavedChanges.saved();
                $location.path('/tenants/'+ tenant.Id);
            });

        vm.isSaving.promise(doSave);
    }

    function deleteTenant() {
        var dlg = octoDialog.confirmDelete('tenant', function () {
            return octopusRepository.Tenants.delete(vm.tenant);
        });
        dlg.then(function (result) {
            if (result) {
                $location.path('/tenants');
            }
        });
    }

    init();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/controllers/tenant_settings_controller.js
// module id = 1374102264251848
// module chunks = 1